<style scoped lang="less"></style>
<template>
	<div>
		<titles titlename="用户类型管理" titlecontent="这里可以管理用户类型" :mbx="paths"></titles>
		<div class="table">
			<el-table :data="tableData" stripe style="width: 100%">
				<el-table-column prop="date" label="类型名称" ></el-table-column>
				<el-table-column prop="name" label="类型编号" ></el-table-column>
				<el-table-column prop="address" label="备注"></el-table-column>
				<el-table-column fixed="right" label="操作">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
						<el-button type="text" size="small">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/basicmanage/Usertypemanage',
					name: '用户类型管理'
				}
			],
			tableData: [
				{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				},
				{
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				},
				{
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}
			]
		};
	},
	components: {
		titles
	}
};
</script>
